import React from "react";
import Button from "../../../../components/Button/Button";
import { useHistory } from "react-router-dom";
import { PAGES } from "../../../../routes/PAGES";
import Block from "../Block";
import styles from "./Blocks.module.scss";

const HowItWorksBlocks = ({ block }) => {
    const history = useHistory();

    const nextPage = () => {
        gtag("event", "welcome", {
            block: block.type,
        });
        history.push(PAGES.REGISTRATION);
    };
    return (
        <Block className={styles.howItWorksBlock}>
            <div className={styles.leftPanel}>
                <div className={styles.info}>
                    <h2>{block.title}</h2>
                    <div>
                        <ol>
                            {block.items.map((item) => {
                                return (
                                    <li key={item.text}>
                                        <span/>
                                        <span dangerouslySetInnerHTML={{ __html:item.text}} />
                                    </li>
                                );
                            })}
                        </ol>
                    </div>
                </div>
                {block.buttonText && (
                    <Button style={styles.button} community rounded onClick={nextPage}>
                        {block.buttonText}
                    </Button>
                )}
            </div>
            <div className={styles.rightPanel}>
                <img
                    src={block.image}
                    alt=""
                    style={{
                        width: "100%",
                        borderRadius: 12,
                    }}
                    className={styles.image}
                />
            </div>
        </Block>
    );
};

export default HowItWorksBlocks;
